export default __webpack_public_path__ + "static/media/arrow-down.2ec9f21b.svg";